




























































































































































import { Vue, Prop, Component } from "vue-property-decorator"
import { MomentInfo } from "@/models/MomentInfo"
import VideoPlayer from "./shared/VideoPlayer.vue"
import IframeVideoPlayer from "./shared/IframeVideoPlayer.vue"
import { SubtitleUrls } from "@/models/SubtitleUrls"
import { EventBus } from "@/event-bus"
import getParams from "@/services/getParams"
@Component({ components: { VideoPlayer, IframeVideoPlayer } })
export default class Carousel extends Vue {
  @Prop({ default: 1 }) public items_to_show!: number
  @Prop({ default: 1 }) public items_to_scroll!: number
  @Prop() public moment!: MomentInfo[]
  @Prop({ default: false }) public is_facebook!: boolean
  @Prop({ default: false }) public is_linkedin!: boolean
  @Prop({ default: false }) public is_twitter!: boolean
  @Prop({ default: false }) public displaybtns!: boolean
  ismobile = false
  slideSize = 0
  slideScrollValue = 0
  slides: Element[] = []
  ismousedown = false
  posX = 0
  tract?: HTMLElement
  curpos = 0
  btnwidth = 0
  slideheight = 0
  btn: HTMLElement[] = []
  hoverOnHighlights = true
  socialShareUrl = ""
  momentId = "-1"
  momentstyle: string = ""
  mounted() {
    this.socialShareUrl = this.$root.$data.socialShareUrl
    if (this.moment.length < 1) return
    this.slideSize =
      (this.$refs.slider as HTMLElement).clientWidth / this.items_to_show
    this.slideScrollValue = this.slideSize * this.items_to_scroll
    this.slides = Array.from(
      (this.$refs.slider as HTMLElement).getElementsByClassName("amplily-slide")
    )
    this.tract = this.$el.getElementsByClassName("s-t")[0] as HTMLElement
    this.tract.setAttribute(
      "style",
      "width:" + this.slideSize * (this.slides.length + 1) + "px !important"
    )
    this.slides.forEach((element: any) => {
      ;(element as HTMLElement).setAttribute(
        "style",
        "width:" + this.slideSize + "px !important;float:left !important"
      )
    })
    this.slideheight = (this.$refs.slider as HTMLElement).clientHeight
    document.addEventListener("touchstart", this.checkismobile)
    this.tract.addEventListener("mousedown", this.mousedown)
    document.addEventListener("mouseup", this.mouseup)
    document.addEventListener("mousemove", this.mousemove)
    this.tract.addEventListener("touchstart", this.mousedown)
    document.addEventListener("touchend", this.mouseup)
    document.addEventListener("touchmove", this.mousemove)
    var prev = this.$el.getElementsByClassName("amplily-prev")[0] as HTMLElement
    var next = this.$el.getElementsByClassName("amplily-next")[0] as HTMLElement
    this.btnwidth = (this.$el.getElementsByClassName(
      "amplily-next"
    )[0] as HTMLElement).clientWidth
    this.btn.push(prev)
    this.btn.push(next)
    this.hoverOnHighlights = false
    this.focus()
    this.snap()
    setTimeout(this.init, 500)
  }
  public checkismobile() {
    this.ismobile = true
    document.removeEventListener("touchstart", this.checkismobile)
  }
  public mousedown() {
    this.ismousedown = true
    if (this.ismobile) {
      var ev = window.event as TouchEvent
      this.posX = ev.touches[0].clientX
    } else {
      var e = window.event as MouseEvent
      this.posX = e.clientX
    }
  }
  public mouseup() {
    this.ismousedown = false
    this.snap()
  }
  public mousemove() {
    if (this.ismousedown) {
      if (!this.tract) {
        return
      }
      var posX = 0
      if (this.ismobile) {
        var ev = window.event as TouchEvent
        posX = this.posX - ev.touches[0].clientX
        this.posX = ev.touches[0].clientX
      } else {
        var e = window.event as MouseEvent
        posX = this.posX - e.clientX
        this.posX = e.clientX
      }
      this.curpos -= posX
      if (!this.curpos) {
        this.curpos = 0
      }
      if (this.curpos < -1 * this.slideSize * (this.slides.length - 1)) {
        this.curpos = -1 * this.slideSize * (this.slides.length - 1)
        posX = 0
      }
      if (this.curpos > 0) {
        this.curpos = 0
        posX = 0
      }
      this.tract.setAttribute(
        "style",
        "width:" +
          this.slideSize * (this.slides.length + 1) +
          "px !important;" +
          "-webkit-transform:translateX(" +
          this.curpos +
          "px)!important;" +
          "-moz-transformtranslateX(" +
          this.curpos +
          "px)!important;" +
          "-o-transform:translateX(" +
          this.curpos +
          "px)!important;"
      )
    }
  }
  snap() {
    if (!this.tract) {
      return
    }
    let minvalue = this.slideSize * this.slides.length
    let slide = this.slides.length - 1
    for (let i = 0; i < this.slides.length; i++) {
      if (
        minvalue >
        Math.abs(
          Math.abs(this.curpos) - i * this.slideSize - this.slideSize * 0.5
        )
      ) {
        slide = i
        minvalue = Math.abs(Math.abs(this.curpos) - i * this.slideSize)
      }
    }
    this.curpos = -1 * this.slideSize * slide
    var val = this.curpos
    this.tract.setAttribute(
      "style",
      "width:" +
        this.slideSize * (this.slides.length + 1) +
        "px !important;" +
        "-webkit-transform:translateX(" +
        val +
        "px)!important;" +
        "-moz-transformtranslateX(" +
        val +
        "px)!important;" +
        "-o-transform:translateX(" +
        val +
        "px)!important;"
    )
  }
  init() {
    if (this.momentId == "") return
    for (let i = 0; i < this.slides.length; i++) {
      var id = (this.slides[i] as HTMLElement).getAttribute("id")
      if (id == this.momentId) {
        this.curpos = i * this.slideSize
        this.snap()
      }
    }
    EventBus.$emit("carouselSetupCompleted")
  }
  focus() {
    var url = window.location.search
    if (url.length == 0) return
    this.momentId = "moment-" + getParams(url)
    var momentdiv = document.getElementById(this.momentId) as HTMLElement
    if (momentdiv) {
      ;(document.getElementById(
        "amplily-slider"
      ) as HTMLElement).scrollIntoView(true)
      this.momentstyle = String(momentdiv.getAttribute("style"))
      momentdiv.setAttribute(
        "style",
        this.momentstyle + ";background-color:#F1D9FF !important"
      )
      setTimeout(this.restoremomentdiv, 2000)
    }
  }
  restoremomentdiv() {
    var momentdiv = document.getElementById(this.momentId) as HTMLElement
    momentdiv.setAttribute(
      "style",
      this.momentstyle +
        ";" +
        "transition: background-color 0.5s linear !important;" +
        "-moz-transition: background-color 0.5s linear !important; " +
        "-webkit-transition: background-color 0.5s linear !important; " +
        "-ms-transition: background-color 0.5s linear !important; "
    )
  }

  prev() {
    if (!this.tract) {
      return
    }
    if (this.curpos + this.slideSize > 0) return
    this.curpos += this.slideSize
    this.tract.setAttribute(
      "style",
      "width:" +
        this.slideSize * (this.slides.length + 1) +
        "px !important;" +
        ";-webkit-transform:translateX(" +
        this.curpos +
        "px)!important;" +
        "-moz-transformtranslateX(" +
        this.curpos +
        "px)!important;" +
        "-o-transform:translateX(" +
        this.curpos +
        "px)!important;" +
        "transition: all 0.7s !important;"
    )
  }
  next() {
    if (!this.tract) {
      return
    }
    if (
      this.curpos - this.slideSize <
      this.slideSize * (this.slides.length - 1) * -1
    )
      return
    this.curpos -= this.slideSize
    this.tract.setAttribute(
      "style",
      "width:" +
        this.slideSize * (this.slides.length + 1) +
        "px !important;" +
        ";-webkit-transform:translateX(" +
        this.curpos +
        "px)!important;" +
        "-moz-transformtranslateX(" +
        this.curpos +
        "px)!important;" +
        "-o-transform:translateX(" +
        this.curpos +
        "px)!important;" +
        "transition: all 0.7s !important;"
    )
  }
  beforeDestroy() {
    document.removeEventListener("mouseup", this.mouseup)
    document.removeEventListener("mousemove", this.mousemove)
  }
}
